<form class="tasks-container">
  <div class="task-box">
    <div class="task-content-container">
      <nwx-next-step-header
        [nextStep]="nextStep$ | async"
        [showTasks]="showTasks"
        [maxSizeMedium]="maxSizeMedium$ | async"
        (clickEvent)="clickEvent.emit($event)"
      ></nwx-next-step-header>

      @if (showTasks) {
        <div class="bolt-col-12 toggle-tasks-body">
          <div class="bolt-row task-product-bar">
            @for (product of products; track product.type; let i = $index) {
              <div
                class="task-product-header"
                >
                <img
                  class="product-image"
                  src="{{ product.imageUrl }}"
                  alt="{{ product.type }} icon"
                  />
                  <h4 class="task-heading">
                    {{ getStatusMessageForProduct(product) }}
                  </h4>
                </div>
              }
            </div>
            <!-----------  Underwriting Issues and EVT Alerts (display as fake task cards) ------------------------>
            <nwx-next-step-uw-issues
              [uwIssues]="uwIssues"
              [disabledProducts]="disabledUwProducts"
              [user]="user$ | async"
              [featureFlags]="featureFlags$ | async"
            ></nwx-next-step-uw-issues>
            <nwx-next-step-evt-alerts
              [evtAlerts]="evtAlerts"
              [savedAgentReply]="savedAgentReply"
            ></nwx-next-step-evt-alerts>
            <!-----------  Remove Product Component ------------------------>
            @if (errorTasks?.length) {
              <nwx-task-list
                [tasks]="errorTasks"
                (taskButtonClicked)="onTaskButtonClicked($event)"
              ></nwx-task-list>
            }
            @if (blockedTasks?.length) {
              <nwx-task-list
                [tasks]="blockedTasks"
                (taskButtonClicked)="onTaskButtonClicked($event)"
              ></nwx-task-list>
            }
            <!-----------  Task List      ---------------------------------->
            @if (tasks?.length) {
              <nwx-task-list
                [tasks]="tasks"
                (taskButtonClicked)="onTaskButtonClicked($event)"
              ></nwx-task-list>
            }
            @if (reviewTasks?.length) {
              <nwx-task-list
                [tasks]="reviewTasks"
                (taskButtonClicked)="onTaskButtonClicked($event)"
              ></nwx-task-list>
            }
          </div>
        }
      </div>
    </div>
  </form>
